import { Link } from 'react-router-dom';
import MyIcon from '../MyIcon/MyIcon';
import Tooltip from '../Tooltip/Tooltip';
import './CardHome.css';

function CardHome({ iconName, iconColor = '#9fa6b2', title, text, link, tooltip, iconFill }) {
  return (
    <div className="card card--home">
      <div className="card-body card-body">
        <div className="card-icon"><MyIcon name={iconName} color={iconColor} fill={iconFill} /></div>
        <div className="card-content">
          <p className="card-title card-title">{title}</p>
          <p className="card-text">{text}</p>
        </div>
      </div>
      {link && (
        <div className="card-footer">
          <Link to={link}>Chi tiết</Link>
        </div>
      )}
      {tooltip && 
        <Tooltip
          content={tooltip}
          title={title}
        />
      }
    </div>
  )
}

export default CardHome;
